class AudioPlayer {
    state = 'stopped'

    audio = null

    play() {
        this.audio.play()
        this.state = 'playing'

        return this
    }

    pause() {
        this.audio.pause()
        this.state = 'paused'

        return this
    }

    stop() {
        this.audio.pause()
        this.audio.currentTime = 0
        this.state = 'stopped'

        return this
    }

    static ringtone() {
        const player = new AudioPlayer()
        player.audio = new Audio('https://nurse-app.clh.test/assets/sounds/ringtone.mp3')

        return player
    }

    static notification() {
        const player = new AudioPlayer()
        player.audio = new Audio('https://nurse-app.clh.test/assets/sounds/notification.mp3')

        return player
    }

    loop() {
        this.audio.loop = true

        return this
    }
}

window.AudioPlayer = AudioPlayer
